import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "suggestions", "hiddenInput", "form", "buttonGroup", "athleteName", "emptyButton", "searchInput"]

  connect() {
    this.timeout = null
  }

  toggleSearch() {
    if (this.hasButtonGroupTarget) this.buttonGroupTarget.classList.add("d-none")
    if (this.hasEmptyButtonTarget) this.emptyButtonTarget.classList.add("d-none")
    this.searchInputTarget.classList.remove("d-none")
    this.inputTarget.focus()
  }

  cancelSearch() {
    // Hide search UI and clear any query/suggestions
    this.searchInputTarget.classList.add("d-none")
    this.inputTarget.value = ""
    this.suggestionsTarget.innerHTML = ""

    // Force-return to the "Not filtered by Athlete" state
    this.hiddenInputTarget.value = ""
    if (this.hasAthleteNameTarget) this.athleteNameTarget.textContent = ""
    if (this.hasButtonGroupTarget) this.buttonGroupTarget.classList.add("d-none")
    if (this.hasEmptyButtonTarget) this.emptyButtonTarget.classList.remove("d-none")
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      const query = this.inputTarget.value
      if (query.length < 2) {
        this.suggestionsTarget.innerHTML = ""
        return
      }

      fetch(`/athletes/search?query=${query}`, {
        headers: {
          "Accept": "text/html"
        }
      })
      .then(response => response.text())
      .then(html => {
        this.suggestionsTarget.innerHTML = html
      })
    }, 300)
  }

  select(event) {
    const athleteId = event.currentTarget.dataset.athleteId
    const athleteName = event.currentTarget.dataset.athleteName

    this.hiddenInputTarget.value = athleteId
    this.athleteNameTarget.textContent = athleteName
    
    this.suggestionsTarget.innerHTML = ""
    this.inputTarget.value = ""
    this.searchInputTarget.classList.add("d-none")
    this.buttonGroupTarget.classList.remove("d-none")

    this.formTarget.requestSubmit()
  }

  clear() {
    this.hiddenInputTarget.value = ""
    this.athleteNameTarget.textContent = ""
    
    this.buttonGroupTarget.classList.add("d-none")
    this.emptyButtonTarget.classList.remove("d-none")
    
    this.formTarget.requestSubmit()
  }
  
  autoSubmit() {
    this.formTarget.requestSubmit()
  }
}
